import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { StylesProvider } from '@material-ui/core/styles';
import App from "./App";
import "./index.css";
import "./utils/chartOptimizer";
import * as serviceWorker from './serviceWorker';
import { registerGlobalFrontendErrorHandlers } from "./services/frontendLogger";

if (process.env.NODE_ENV === 'development' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
    console.log('Service Worker desregistrado para desenvolvimento');
  });
}

registerGlobalFrontendErrorHandlers();

ReactDOM.render(
  <React.StrictMode>
    <StylesProvider injectFirst>
      <CssBaseline>
        <App />
      </CssBaseline>
    </StylesProvider>
  </React.StrictMode>,
  document.getElementById("root"),
  () => {
    if (typeof window.finishProgress === "function") {
      setTimeout(() => {
        window.finishProgress();
      }, 300);
    }
  }
);

serviceWorker.register();
